/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCbsaPort.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/cbsa-port";

export class AutogenModelCbsaPort<RowType extends ModelRow> extends Endpoint<RowType, RowCbsaPortFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCbsaPort extends ModelRow<RowCbsaPortFields> {
	constructor(values?: Partial<RowCbsaPortFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCbsaPortFields {
	company_id: string;
	district_name: string;
	port_code: string;
	port_name: string;
}

